// Criativos (imagens) da empresa.
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { AssetDto, AssetListResponse } from '@impulso/shared/api/builder'
import { api } from '../../lib/api'

export const assetsKey = (companyId: string) => ['assets', companyId] as const

export function useAssets(companyId: string) {
  return useQuery({
    queryKey: assetsKey(companyId),
    queryFn: () => api.get<AssetListResponse>(`/companies/${companyId}/assets`),
    staleTime: 30 * 60_000, // links assinados valem 1h
  })
}

export function useUploadAsset(companyId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (file: File) => {
      const form = new FormData()
      form.append('file', file)
      return api.upload<AssetDto>(`/companies/${companyId}/assets`, form)
    },
    onSuccess: (asset) => {
      qc.setQueryData<AssetListResponse>(assetsKey(companyId), (old) => ({ items: [asset, ...(old?.items ?? []).filter((a) => a.id !== asset.id)] }))
    },
  })
}

export function useDeleteAsset(companyId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (assetId: string) => api.del<void>(`/companies/${companyId}/assets/${assetId}`),
    onSuccess: (_v, assetId) => {
      qc.setQueryData<AssetListResponse>(assetsKey(companyId), (old) => ({ items: (old?.items ?? []).filter((a) => a.id !== assetId) }))
    },
  })
}
